import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidePanelExpandAllService {
  private readonly _collapseChange$ = new Subject<void>();
  collapseChange$ = this._collapseChange$.asObservable();

  triggerCollapseChange(): void {
    this._collapseChange$.next();
  }
}
